
import wx from 'weixin-js-sdk'
import html2canvas from 'html2canvas'
import { funcUrlDel, nowInDateBetwen } from '@/libs/utils'
import config from '@/config/index'
import {
getPartyVoteDetail,
addVotePartyVotelog,
addCount
} from '@/api/youzheng'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'

import { getConfig } from '@/api/wx.js'
import { operateCreditlist } from '@/api/user'
export default {
directives: {
TransferDom
},
components: {
Swiper,
SwiperItem,
XDialog,
Qrcode,
InlineXNumber
},
props: ['partyObj'],
data () {
return {
baseUrl: this.$config.baseUrl,
partyid: this.$route.params.artid,
voteid: this.$route.params.voteid,
openid: this.$storage.get('openid'),
obj: {},
imglist: [],
showDialog: false,
showDialogShare: false,
downImgUrl: '',
qrcodeUrl: '',
votenum: 1,
voteTotal: 0, // 可投票数量
status: 0, // 0还未开始，1正在进行，-1结束
showbtn: true
}
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
created () {
this.wxconfig()
this.status = nowInDateBetwen(
this.partyObj.votestartdate,
this.partyObj.voteenddate
)
this.getDetail()
this.getCount()
},
methods: {
getDetail () {
getPartyVoteDetail({
id: this.voteid,
openid: this.openid
}).then(data => {
this.obj = data.obj
if (this.obj.attList.length > 0) {
this.imglist = this.obj.attList.map(
item => this.baseUrl + item.FILEPATH
)
}
})
},
showShare () {
this.share()
},

shareImg () {
html2canvas(this.$refs.imageWrapper, { scrollY: 0 }).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
},

share () {
this.qrcodeUrl =
'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
config.appid +
'&redirect_uri=' +
funcUrlDel('code') +
'/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
this.showDialogShare = true
setTimeout(() => {
this.shareImg()
}, 500)
},
showDialogFun () {
this.showDialog = true
},

vote () {
this.showbtn = false

let voteids = []
for (let i = 0; i < this.votenum; i++) {
voteids.push(this.obj.id)
}
addVotePartyVotelog({
partyid: this.partyid,
voteids: voteids.join(','),
openid: this.userid,
source: 1
})
.then(data => {
this.showDialog = false
this.$vux.toast.text('投票成功！')
this.showbtn = true
this.$set(this.obj, 'tongji', this.obj.tongji + this.votenum)
this.voteTotal -= this.votenum

operateCreditlist({
accountid: this.accountid,
rulecode: 'vote',
credit: 1,
owner_type: this.$config.owner_type,
terminaltype: 2
})
})
.catch(() => {
this.showDialog = false
})
},

getCount () {
addCount({
partyid: this.partyid,
openid: this.userid
}).then(res => {
this.voteTotal = this.partyObj.voteMax - res.obj 
})
},

wxconfig () {
let ua = window.navigator.userAgent.toLowerCase()

let href = window.location.href.split('#')[0]
if (
ua.match(/MicroMessenger/i) == 'micromessenger' &&
ua.match(/wxwork/i) == 'wxwork'
) {
href = window.location.href.split('#')[0]

} else if (ua.match(/micromessenger/i) == 'micromessenger') {
href = this.$store.state.user.wechatSignUrl

}
getConfig({
url: href
}).then(re => {
var configs = re.returnValue
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: configs.appId, // 必填，公众号的唯一标识
timestamp: configs.timestamp, // 必填，生成签名的时间戳
nonceStr: configs.nonceStr, // 必填，生成签名的随机串
signature: configs.signature, // 必填，签名，见附录1
jsApiList: ['previewImage'] 
})
})
},

preview (index, fileList) {
wx.previewImage({
current: fileList[index], // 当前显示图片的http链接
urls: fileList 
})
}
}
}
